import { render, staticRenderFns } from "./embeded.vue?vue&type=template&id=324b8ad4&scoped=true&"
import script from "./embeded.vue?vue&type=script&lang=js&"
export * from "./embeded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324b8ad4",
  null
  
)

export default component.exports